import { getLanding } from "../service/club/api";
import { parseAgreementToTheme } from "../service/club/utils";

const SLUG_MAPPINGS: Record<string, string> = {
  'viuvantagens': 'viu',
  'localhost': 'fibralinkvantagens',
  'b28': 'grajavantagens',
  'pandavantagens': 'pandavantagens',
  'club.cyberinternet.com.br': 'cyberclub'
};

function extractSlugFromHostname(): string {
  const hostname = window.location.hostname;
  
  if (hostname.includes('partiu.com.br')) {
    return hostname.split('.')[0];
  }
  
  return hostname;
}

function mapSlugToTheme(slug: string): string {
  for (const [key, value] of Object.entries(SLUG_MAPPINGS)) {
    if (slug.includes(key)) {
      return value;
    }
  }
  
  return slug;
}

export async function themeResolver() {
  try {
    const extractedSlug = extractSlugFromHostname();
    const themeSlug = mapSlugToTheme(extractedSlug);
    
    const response = await getLanding(themeSlug);
    return parseAgreementToTheme(response);
  } catch (error) {
    return null;
  }
}
